<mat-card class="breadcrumb">
    <div class="row">
        <div class="col-md-7">
            <!--<a [routerLink]="['/dashboard']">Dashboard</a>-->
            <!--<mat-icon>arrow_forward_ios</mat-icon>-->
            <a [routerLink]="['/open-table/issues']">Open Table Issues</a>
        </div>
        <div class="col-md-5 text-right">

        </div>
    </div>
</mat-card>



<mat-card class="no-records" *ngIf="!data.length">
    No errors listed
</mat-card>

<ng-container *ngIf="data.length">

    <div class="margin-top-20">


        <table class="mat-elevation-z2 example-full-width data-listing">
            <thead>
            <tr>
                <th>Created</th>
                <th>Spa Date</th>

                <th>Customer name</th>
                <th>Email</th>

                <th>Guests</th>
                <th>Order ref</th>
                <th>Error</th>
                <!-- <th></th> -->
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let d of data">
                <td class="hover">{{d.createdAt | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td class="hover">{{d.startTime | date: 'dd/MM/yyyy HH:mm'}}</td>
                <td class="hover">
                    {{d.name}}
                </td>
                <td class="hover">
                    {{d.email}}
                </td>
<!--                <td class="hover"> {{d.customer.telephone}}</td>-->
                <td class="hover">{{d.guests}}
                </td>
                <td class="hover">
                     <a class="hover" [href]="'https://app.try.be/orders/' + d.bookingId" target="_blank">{{d.orderRef}}</a>
                </td>
                <td class="hover">
                    {{d.otError}}
                </td>

            </tr>
            </tbody>
        </table>

    </div>


</ng-container>
